import { render, staticRenderFns } from "./InfocardCoverUploadModal.vue?vue&type=template&id=ef131afe&scoped=true&"
import script from "./InfocardCoverUploadModal.vue?vue&type=script&lang=js&"
export * from "./InfocardCoverUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./InfocardCoverUploadModal.vue?vue&type=style&index=0&id=ef131afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef131afe",
  null
  
)

export default component.exports